// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c4f53e77","732":"8dbfe0f4","977":"432d88d5"}[chunkId] + ".chunk.js";
};